"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/KRFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_128)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_128`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0H24V24H0V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.6041 15.8419L17.7652 14.6808L18.5392 15.4548L17.3781 16.616L16.6041 15.8419ZM14.6726 17.7743L15.8337 16.6131L16.6078 17.3872L15.4467 18.5483L14.6726 17.7743ZM18.925 18.1603L20.0861 16.9992L20.8602 17.7732L19.6991 18.9343L18.925 18.1603ZM16.99 20.0949L18.1512 18.9338L18.9252 19.7078L17.7641 20.869L16.99 20.0949ZM17.7606 17L18.9218 15.8389L19.6958 16.6129L18.5347 17.7741L17.7606 17ZM15.8338 18.9371L16.9949 17.776L17.769 18.55L16.6079 19.7112L15.8338 18.9371ZM15.8378 5.01974L16.6118 4.24571L19.7032 7.33708L18.9291 8.11111L15.8378 5.01974ZM14.6765 6.17743L15.4505 5.40339L16.6117 6.56451L15.8377 7.33855L14.6765 6.17743ZM16.6038 8.10683L17.3778 7.3328L18.539 8.49392L17.7649 9.26795L16.6038 8.10683ZM16.99 3.85448L17.764 3.08044L18.9252 4.24157L18.1511 5.0156L16.99 3.85448ZM18.9195 5.79448L19.6936 5.02044L20.8547 6.18157L20.0806 6.9556L18.9195 5.79448ZM3.07019 17.7798L3.8443 17.0058L6.93566 20.0971L6.16163 20.8712L3.07019 17.7798ZM6.16205 18.5515L6.93608 17.7775L8.09728 18.9385L7.32317 19.7127L6.16205 18.5515ZM4.23173 16.6121L5.00584 15.8381L6.16696 16.9992L5.39293 17.7732L4.23173 16.6121ZM5.39279 15.4541L6.16689 14.6801L9.25833 17.7715L8.48423 18.5455L5.39279 15.4541ZM3.07496 6.17637L6.16626 3.08494L6.9403 3.85904L3.84907 6.95041L3.07496 6.17637ZM4.23152 7.3335L7.32275 4.24213L8.09686 5.01616L5.00549 8.1076L4.23152 7.3335ZM5.39054 8.50129L8.48198 5.40992L9.25602 6.18395L6.16465 9.27539L5.39054 8.50129Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9509 16.3509C14.3655 16.3509 16.3228 14.3935 16.3228 11.979C16.3228 9.56443 14.3655 7.60706 11.9509 7.60706C9.53636 7.60706 7.57898 9.56443 7.57898 11.979C7.57898 14.3935 9.53636 16.3509 11.9509 16.3509Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.2948 12.5123C15.6211 10.7298 13.186 10.7579 11.9579 12.6035C10.7229 14.4491 8.88425 13.7895 7.63513 12.6527C7.95794 14.7509 9.76846 16.3509 11.9579 16.3509C14.1895 16.3509 16.0281 14.6737 16.2948 12.5123Z",
					fill: "#0052B4"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_128`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as KRFlag };
